// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"4a7a26d5","412":"608bef65","449":"e9ca5b73","892":"7e040924"}[chunkId] + ".chunk.js";
};